import { t } from 'ttag'

import { IndustryIcon } from '@h2/components/icons/industry'
import { ThumbsUpActiveIcon } from '@h2/components/icons/thumbsUpActive'
import { ContentStandardsIcon } from '@h2/components/icons/contentStandards'
import { SLB, SO } from '@h2/components/colors'
import { NetworkIcon } from '@h2/components/icons/network'

import { ThingsToAction } from './common/overview/thingsToAction'
import { KeyStatistics } from './common/overview/keyStatistics'
import { Overview } from './common/overview'

import { OverviewItem } from '../components/common/overview/overviewItem'
import { addCommas } from '../utils'

const LocalOpportunitiesOverview = ({ dashboard, isFetching }) => {
  const uncompleted = dashboard?.localOpportunities?.outstandingApplications
  const unapproved = dashboard?.localOpportunities?.unapprovedContacts
  const totalCompanies = dashboard?.localOpportunities?.totalCompanies
  const totalContacts = dashboard?.localOpportunities?.totalContacts
  const applications = dashboard?.localOpportunities?.applications

  return (
    <Overview
      icon={NetworkIcon}
      title={t`Local Opportunities`}
      dropdown={{
        text: t`Actions`,
        items: [
          {
            icon: IndustryIcon,
            text: t`Invite a company`,
            href: '/management/localopportunities/companies'
          },
          {
            icon: ThumbsUpActiveIcon,
            text: t`Open contact queue`,
            href: '/management/localopportunities/queue'
          },
          {
            icon: ContentStandardsIcon,
            text: t`View applications`,
            href: '/management/localopportunities/tasks'
          }
        ]
      }}>
      <ThingsToAction>
        <OverviewItem isFetching={isFetching} width="50%">
          <OverviewItem.Heading color={SO}>
            {addCommas(uncompleted?.total)}
          </OverviewItem.Heading>
          <OverviewItem.Text>{t`Outstanding Applications`}</OverviewItem.Text>
          <OverviewItem.Button to="/management/localopportunities/tasks">
            {t`Review now`}
          </OverviewItem.Button>
        </OverviewItem>

        <OverviewItem isFetching={isFetching} width="50%">
          <OverviewItem.Heading color={SO}>
            {addCommas(unapproved?.total)}
          </OverviewItem.Heading>
          <OverviewItem.Text>{t`Unapproved contacts`}</OverviewItem.Text>
          <OverviewItem.Button to="/management/localopportunities/queue">{t`Review now`}</OverviewItem.Button>
        </OverviewItem>
      </ThingsToAction>
      <KeyStatistics>
        <OverviewItem isFetching={isFetching}>
          <OverviewItem.Heading color={SLB}>
            {addCommas(totalCompanies?.total)}
          </OverviewItem.Heading>
          <OverviewItem.Text size="small" align="center">
            {t`Total Companies`}
          </OverviewItem.Text>
          <OverviewItem.Button to="/management/localopportunities/companies" color="blue">
            {t`View here`}
          </OverviewItem.Button>
        </OverviewItem>

        <OverviewItem isFetching={isFetching}>
          <OverviewItem.Heading color={SLB}>
            {addCommas(totalContacts?.total)}
          </OverviewItem.Heading>
          <OverviewItem.Text size="small" align="center">
            {t`Total Contacts`}
          </OverviewItem.Text>
          <OverviewItem.Button to="/management/localopportunities/contacts" color="blue">
            {t`View here`}
          </OverviewItem.Button>
        </OverviewItem>

        <OverviewItem isFetching={isFetching}>
          <OverviewItem.Heading color={SLB}>
            {addCommas(applications?.total)}
          </OverviewItem.Heading>
          <OverviewItem.Text size="small" align="center">
            {t`Applications Received`}
          </OverviewItem.Text>
          <OverviewItem.Chart data={applications?.dataPoints} />
        </OverviewItem>
      </KeyStatistics>
    </Overview>
  )
}

export { LocalOpportunitiesOverview }
